@if (!isFullSize) {
  <div class="live-drop__hover" [class.live-drop__hover_static]="!liveDrop.item">
    <div class="live-drop__amount" [convert]="liveDrop.amountUsd"></div>

    @if (liveDrop.type === liveDropType.GAME && liveDrop.mode) {
      <img
        loading="lazy"
        fetchpriority="low"
        class="live-drop__img live-drop__live-drop-img"
        [src]="liveDropImage[liveDrop.mode]"
        alt=""
      />
    } @else if (liveDrop.type === liveDropType.SERVICE_ITEM && liveDrop.serviceItem) {
      <img
        loading="lazy"
        fetchpriority="low"
        class="live-drop__img live-drop__live-drop-img"
        [src]="liveDrop.serviceItem.image.fileName | serviceItemImage"
        alt=""
      />
    }

    <div class="live-drop__user-name">
      {{ liveDrop.user.nickname }}
    </div>
  </div>
}

@if (liveDrop.item) {
  <div class="live-drop__content live-drop__skin drop-skin">
    @if (isFullSize) {
      <div class="drop-skin__nickname">
        {{ liveDrop.user.nickname }}
      </div>

      <div class="drop-skin__price" [convert]="liveDrop.amountUsd"></div>
    }
    <div class="drop-skin__wrapper">
      @if (isCsgoItem(liveDrop.item)) {
        <div class="drop-skin__title">
          {{ liveDrop.item.extra.n[1] }}
        </div>

        <div class="drop-skin__type">
          <span class="drop-skin__extra !text-[1.1rem] !text-[#CDDBFF] !leading-[1.4rem]">
            {{ liveDrop.item.extra.n[0] }}
          </span>

          <span class="drop-skin__exterior !text-[1.1rem] !text-[#CDDBFF] !leading-[1.4rem]">
            {{ liveDrop.item.extra | itemExterior: liveDrop.item.appId }}
          </span>

          @if (liveDrop.item.extra.st) {
            <span class="drop-skin__st !text-[1.1rem] !text-[#CDDBFF] !leading-[1.4rem]">ST</span>
          }
        </div>
      } @else {
        <div class="drop-skin__title" [class.is-full-size]="isFullSize">
          {{ liveDrop.item.marketName }}
        </div>

        <div class="drop-skin__type">
          <span class="drop-skin__nocs !text-[1.1rem] !text-[#CDDBFF] !leading-[1.4rem]" [class.is-full-size]="isFullSize">
            {{ liveDrop.item.extra | itemExterior: liveDrop.item.appId }}
          </span>
        </div>
      }
    </div>

    <img
      loading="lazy"
      fetchpriority="low"
      class="drop-skin__img"
      [src]="liveDrop.item.id | itemImage: 'medium'"
      [alt]="liveDrop.item.marketName"
      [class.is-full-size]="isFullSize"
    />

    <div class="drop-skin__light" [itemLight]="liveDrop.item.extra | itemColor: liveDrop.item.appId"></div>
  </div>
}

@if (liveDrop.isBigWin) {
  <div class="live-drop__big-win">Big win</div>
}
